import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../../api";
import { BrandLogo } from "../../icons";
import { safeNext } from "./AuthContext";
import { AuthFrame } from "./AuthScreen";

/** Local development only: the shared password from .dev.vars (LOCAL_ADMIN_PASSWORD). Deployed environments use Clerk. */
export default function LocalLogin() {
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  const [params] = useSearchParams();

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.login(password);
      nav(safeNext(params.get("redirect_url") ?? params.get("next")), { replace: true });
    } catch (err: any) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthFrame>
      <form className="panel" onSubmit={submit}>
        <div className="login-head">
          <h1><BrandLogo className="brand-logo brand-logo-lg" /></h1>
          <p className="small muted">Admin console for building and sharing interactive product tours.</p>
        </div>
        <label className="field">
          <span>Local admin password</span>
          <input type="password" autoFocus autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} />
        </label>
        {error && <div className="error-box">{error}</div>}
        <button className="btn btn-primary" disabled={busy || !password}>{busy ? "Signing in…" : "Sign in"}</button>
        <p className="small muted">Local development sign-in. Deployed environments sign in with your account instead.</p>
      </form>
    </AuthFrame>
  );
}
